// redux/services/scholarshipsService/scholarships.Service.js
import { baseApi } from "../baseApi";

export const AdminEducationApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // ======================
        // GET ALL SCHOLARSHIPS (Admin)
        // ======================
        getAdminScholarships: builder.query({
            query: ({
                page = 1,
                limit = 10,
                status = "",
                category = "",
                type = "",
                search = "",
            } = {}) =>
                `/scholarships?page=${page}&limit=${limit}&status=${status}&category=${category}&type=${type}&search=${search}`,
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result.data.map(({ id }) => ({ type: "AdminEducation", id })),
                        { type: "AdminEducation", id: "LIST" },
                    ]
                    : [{ type: "AdminEducation", id: "LIST" }],
        }),

        // ======================
        // GET SCHOLARSHIP BY ID (Admin)
        // ======================
        getAdminScholarship: builder.query({
            query: (id) => `/scholarship/${id}`,
            providesTags: (result, error, id) => [{ type: "AdminEducation", id }],
        }),

        // ======================
        // GET SCHOLARSHIP APPLICATIONS (Admin)
        // ======================
        getScholarshipApplications: builder.query({
            query: (scholarship_id) => `/scholarship-applications/${scholarship_id}`,
            providesTags: (result, error, scholarship_id) => [{ type: "AdminEducation", scholarship_id }],
        }),

        // ======================
        // GET STUDENT REGISTRATION BY ID (Admin)
        // ======================
        getStudentRegistration: builder.query({
            query: (id) => `/student-registration/${id}`,
            providesTags: (result, error, id) => [{ type: "AdminEducation", id }],
        }),

        // ======================
        // CREATE SCHOLARSHIP (Admin)
        // ======================
        createScholarship: builder.mutation({
            query: (data) => ({
                url: "/scholarship-create",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["AdminEducation"],
        }),

        // ======================
        // UPDATE SCHOLARSHIP (Admin)
        // ======================
        updateScholarship: builder.mutation({
            query: ({ id, data }) => ({
                url: `/scholarship-update/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: "AdminEducation", id },
                { type: "AdminEducation", id: "LIST" },
            ],
        }),

        // ======================
        // DELETE SCHOLARSHIP (Admin)
        // ======================
        deleteScholarship: builder.mutation({
            query: (id) => ({
                url: `/scholarship-delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: (result, error, id) => [
                { type: "AdminEducation", id },
                { type: "AdminEducation", id: "LIST" },
            ],
        }),

        // ======================
        // UPDATE SCHOLARSHIP STATUS (Admin)
        // ======================
        updateScholarshipStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `/scholarship-status/${id}`,
                method: "PUT",
                body: { status },
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: "AdminEducation", id },
                { type: "AdminEducation", id: "LIST" },
            ],
        }),

        // ======================
        // GET SCHOLARSHIP STATISTICS (Admin)
        // ======================
        getScholarshipStatistics: builder.query({
            query: () => "/scholarship-statistics",
            providesTags: ["AdminEducation"],
        }),

        // ======================
        // GET STUDENT REGISTRATIONS (Admin)
        // ======================
        getStudentRegistrations: builder.query({
            query: ({
                page = 1,
                limit = 10,
                status = "",
                search = "",
            } = {}) =>
                `/student-registrations?page=${page}&limit=${limit}&status=${status}&search=${search}`,
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result.data.map(({ id }) => ({ type: "AdminEducation", id })),
                        { type: "AdminEducation", id: "LIST" },
                    ]
                    : [{ type: "AdminEducation", id: "LIST" }],
        }),

        // ======================
        // UPDATE STUDENT STATUS (Admin)
        // ======================
        updateStudentStatus: builder.mutation({
            query: ({ id, status, remarks }) => ({
                url: `/student-status/${id}`,
                method: "PUT",
                body: { status, remarks },
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: "AdminEducation", id },
                { type: "AdminEducation", id: "LIST" },
            ],
        }),
    }),
});

export const {
    // Queries
    useGetAdminScholarshipsQuery,
    useGetAdminScholarshipQuery,
    useGetScholarshipApplicationsQuery,
    useGetStudentRegistrationQuery,
    useGetScholarshipStatisticsQuery,
    useGetStudentRegistrationsQuery,

    // Mutations
    useCreateScholarshipMutation,
    useUpdateScholarshipMutation,
    useDeleteScholarshipMutation,
    useUpdateScholarshipStatusMutation,
    useUpdateStudentStatusMutation,
} = AdminEducationApi;

export default AdminEducationApi;